<template>
  <div class="login-wrapper">
    <div class='content'>
      <div class="logo">
        <img src="@/assets/images/logo-ht.png" />
      </div>
      <div class='tab-wrapper'>
        <div class='tab-li' :class="{'active': tabIndex==1}" @click='()=>{tabIndex=1}'>账号登录</div>
        <div class='tab-li' :class="{'active': tabIndex==2}" @click='()=>{tabIndex=2}'>验证码登录</div>
      </div>
      <van-field
      class="vant-set"
      readonly
      clickable
      name="picker"
      :value="columnValue"
      placeholder="点击选择城市"
      @click="showPicker = true"
      v-if="tabIndex==1" />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false" />
      </van-popup>
      <van-cell-group v-show='tabIndex!=2'>
        <template v-if="columnValue=='医生'">
          <van-field v-model.trim="username" name="username" placeholder="请输入账号" @blur="handleBlur('username')" clearable />
          <div class="error-msg" v-show='usernameErrMsg'>请输入账号</div>
          <van-field v-model.trim="password" name="password" type="password" placeholder="请输入密码" @blur="handleBlur('password')" autocomplete="off" clearable />
          <div class="error-msg" v-show='passwordErrMsg'>请输入密码</div>
        </template>
        <template v-else>
          <van-field v-model.trim="doctorname" name="doctorname" placeholder="请输入医生账号" @blur="handleBlur('doctorname')" clearable />
          <div class="error-msg" v-show='doctornameErrMsg'>医生账号未填写，请填写后重试</div>
          <van-field v-model.trim="usersubname" name="usersubname" placeholder="请输入子账号" @blur="handleBlur('usersubname')" clearable />
          <div class="error-msg" v-show='usersubnameErrMsg'>子账号未填写，请填写后重试</div>
          <van-field v-model.trim="subpassword" name="subpassword" type="password" placeholder="请输入密码" @blur="handleBlur('subpassword')" autocomplete="off" clearable />
          <div class="error-msg" v-show='subpasswordErrMsg'>子账号密码未填写，请填写后重试</div>
        </template>
      </van-cell-group>
      <van-cell-group v-show='tabIndex==2' inset>
        <van-field v-model.trim="mobile" name="mobile" placeholder="请输入手机号码" @input="changeAccount" clearable />
        <div class="error-msg" v-show='mobileErrMsg1||mobileErrMsg2'>{{mobileErrMsg1?'请输入手机号码':'请输入正确的手机号码'}}</div>
        <van-field v-model.trim="imageCode" name="imageCode" placeholder="图形验证码" autocomplete="off" clearable>
          <div slot="button" class="tCode pointer" v-loading="codeLoading" :style="{background: `url(${tCode}) center center / cover no-repeat`}" @click="changeTCode"></div>
        </van-field>
        <van-field v-model.trim="code" name="code" type="password" placeholder="请输入验证码" @blur="handleBlur('code')">
          <vericode slot='button' :send-code='sendCode' :disable='imageCode.length !== 4' @send-code='handleSendCode'></vericode>
        </van-field>
        <div class="error-msg" v-show='codeErrMsg1||codeErrMsg2'>{{codeErrMsg1?'请输入验证码':'请输入6位数字验证码'}}</div>
      </van-cell-group>
      <van-cell-group>
        <div class="link-wrap">
          <a class="forget-pwd link" @click="handleForgetPwd">忘记密码</a>
        </div>
        <van-button round type="primary" size="large" :disabled="saveDisabled" @click="handleLogin">登录</van-button>
        <div class="register-link link" @click="handleRegister" v-if="columnValue!=='子账号'">注册</div>
        <div class="login-qrcode" v-if="columnValue!=='子账号'">
          <img src="@/assets/images/qrcode.png" />
          <span>正雅医生app</span>
        </div>
      </van-cell-group>
    </div>
  </div>
</template>
<script>
import md5 from 'js-md5'
import Vericode from '@/components/member/vericode'
import { Toast } from 'vant'
export default {
  components: {
    Vericode
  },
  data () {
    return {
      imageCode: '',
      isMobile: false,
      vCode: '',
      codeLoading: false,
      tCode: '',
      guid: '',
      showPicker: false,
      columns: ['医生', '子账号'],
      columnValue: '医生',
      scode: false,
      usernameErrMsg: false,
      passwordErrMsg: false,
      mobileErrMsg1: false,
      mobileErrMsg2: false,
      codeErrMsg1: false,
      codeErrMsg2: false,
      codeTimmer: null, // 倒计时计时器
      codeBtnText: '发送验证码',
      sendCodeDisabled: true,
      tabIndex: 1,
      sendCode: false,
      mobile: '',
      code: '',
      phone: '',
      username: '',
      doctorname: '',
      usersubname: '',
      subpassword: '',
      doctornameErrMsg: '',
      usersubnameErrMsg: '',
      subpasswordErrMsg: '',
      password: '',
      saveDisabled: false
    }
  },
  watch: {
    scode: {
      handler (val, oldVal) {
        this.sendCode = val
      }
    }
  },
  methods: {
    changeAccount (val) {
      this.isMobile = val && !(val.indexOf('@') > -1) && !isNaN(val) && val.length === 11
      if (this.isMobile) {
        this.vCode = localStorage.getItem('VCode')
        this.guid = this.getGuid()
        this.tCode = this.vCode + 'imageid=' + this.guid
      }
    },

    changeTCode () {
      this.codeLoading = true
      this.tCode = this.vCode + 'imageid=' + this.guid + '&t=' + (new Date ()).getTime()
      this.codeLoading = false
    },

    getGuid () {
      function S4() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
      }
      return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
    },
    onConfirm (val) {
      this.columnValue = val
      this.showPicker = false
    },
    handleBlur (temp) {
      switch (temp) {
        case 'username':
          if (!this.username.length) {
            this.usernameErrMsg = true
          } else {
            this.usernameErrMsg = false
          }
          break
        case 'password':
          if (!this.password.length) {
            this.passwordErrMsg = true
          } else {
            this.passwordErrMsg = false
          }
          break
        case 'usersubname':
          if (!this.usersubname.length) {
            this.usersubnameErrMsg = true
          } else {
            this.usersubnameErrMsg = false
          }
          break
        case 'doctorname':
          if (!this.doctorname.length) {
            this.doctornameErrMsg = true
          } else {
            this.doctornameErrMsg = false
          }
          break
        case 'subpassword':
          if (!this.subpassword.length) {
            this.subpasswordErrMsg = true
          } else {
            this.subpasswordErrMsg = false
          }
          break
        case 'mobile':
          if (!this.mobile.length) {
            this.mobileErrMsg1 = true
          } else {
            this.mobileErrMsg1 = false
            let str = /^1[3456789]\d{9}$/
            if (!str.test(this.mobile)) {
              this.mobileErrMsg2 = true
            } else {
              this.mobileErrMsg2 = false
              this.sendCodeDisabled = false
            }
          }
          break
        case 'code':
          if (!this.code.length) {
            this.codeErrMsg1 = true
          } else {
            this.codeErrMsg1 = false
            let str = /^([0-9]{6})$/
            if (!str.test(this.code)) {
              this.codeErrMsg2 = true
            } else {
              this.codeErrMsg2 = false
            }
          }
          break
      }
    },
    handleSendCode () {
      this.scode = true
      let CheckUserMobile = {
        AppID: 15,
        Method: 'CheckUserMobile',
        Mobile: this.mobile, // 手机号
        Channel: 0, // 用户渠道 0 医生 1 渠道
        IsSendCode: true, // 是否发送验证码
        ImageID: this.isMobile ? this.guid : '', // 图片编号:Type==1必填,Type==3必填
        ImageCode: this.isMobile ? this.imageCode : ''// 图片验证码:Type==1必填,Type==3必填 
      }
      this.$Request(CheckUserMobile)
    },
    // 登录
    handleLogin () {
      let result = false
      // 验证
      if (this.tabIndex == 1) {
        if (this.columnValue === '医生') {
          if (!this.username.length) {
            this.usernameErrMsg = true
          } else {
            this.usernameErrMsg = false
          }
          if (!this.password.length) {
            this.passwordErrMsg = true
          } else {
            this.passwordErrMsg = false
          }
          result = !this.usernameErrMsg && !this.passwordErrMsg
        } else {
          if (!this.doctorname.length) {
            this.doctornameErrMsg = true
          } else {
            this.doctornameErrMsg = false
          }
          if (!this.usersubname.length) {
            this.usersubnameErrMsg = true
          } else {
            this.usersubnameErrMsg = false
          }
          if (!this.subpassword.length) {
            this.subpasswordErrMsg = true
          } else {
            this.subpasswordErrMsg = false
          }
          result = !this.usersubnameErrMsg && !this.doctornameErrMsg && !this.doctornameErrMsg
        }
      }
      if (this.tabIndex == 2) {
        if (!this.mobile.length) {
          this.mobileErrMsg1 = true
        } else {
          this.mobileErrMsg1 = false
          let str = /^1[3456789]\d{9}$/
          if (!str.test(this.mobile)) {
            this.mobileErrMsg2 = true
          } else {
            this.mobileErrMsg2 = false
          }
        }
        if (!this.code.length) {
          this.codeErrMsg1 = true
        } else {
          this.codeErrMsg1 = false
          let str = /^([0-9]{6})$/
          if (!str.test(this.code)) {
            this.codeErrMsg2 = true
          } else {
            this.codeErrMsg2 = false
          }
        }
        result = !this.mobileErrMsg1 && !this.mobileErrMsg2 && !this.codeErrMsg1 && !this.codeErrMsg2
      }
      if (result) {
        this.saveDisabled = true
        Toast.loading({
          duration: 0,
          message: '正在登录...',
          overlay: true
        })
        if (this.tabIndex == '1') {
          let Params = {}
          if (this.columnValue === '医生') {
            Params = {
              AppID: this.GLOBAL.AppID, // 应用号
              Method: 'Login', // 接口名称
              Account: this.username, // 帐号
              Password: md5(this.password).toUpperCase()
            }
          } else {
            Params = {
              AppID: this.GLOBAL.AppID, // 应用号
              Method: 'SubLogin', // 接口名称
              MainAccount: this.doctorname, // 帐号
              Account: this.usersubname,
              Password: md5(this.subpassword).toUpperCase()
            }
          }

          this.$store.dispatch('LoginByUsername', Params).then((res) => {
            Toast.clear()
            setTimeout(() => {
              this.saveDisabled = false
              this.$store.commit('SET_IS_FIRST_LOGIN', true)
              this.$router.push({ path: '/patient-manage/list', replace: true })
            }, 1000)
          }, err => {
            setTimeout(() => {
              Toast.clear()
              this.saveDisabled = false
            }, 3000)
          })
        } else {
          let Params = {
            AppID: this.GLOBAL.AppID, // 应用号
            Method: 'CheckVerifyCode',
            Mobile: this.mobile, // 用户手机号
            VerifyCode: this.code, // 验证码
            Channel: 0 // 用户渠道
          }
          this.$store.dispatch('LoginByUsername', Params).then((res) => {
            if (res.IsSuccess) {
              Toast.clear()
              setTimeout(() => {
                this.saveDisabled = false
                this.$store.commit('SET_IS_FIRST_LOGIN', true)
                this.$router.push({ path: '/patient-manage/list', replace: true })
              }, 1000)
            } else {
              Toast.loading({
                duration: 3000,
                message: res.Error,
                overlay: true
              })
              this.saveDisabled = false
            }
          }, err => {
            setTimeout(() => {
              Toast.clear()
              this.saveDisabled = false
            }, 3000)
          })
        }
      }
    },
    handleRegister () {
      this.$router.push({ path: 'register', replace: true })
    },
    handleForgetPwd () {
      this.$router.push({ path: 'forget-pwd', replace: true })
    }
  }
}
</script>
<style lang="less" scoped>
.tCode {
  width: 160px;
  height: 60px;
}

.pointer {
  cursor: pointer;
}
.login-wrapper {
  input:-internal-autofill-selected {
    background-color: white !important;
  }
  .error-msg {
    color: red;
    font-size: 12px;
    padding-left: 30px;
    margin-top: 10px;
  }
  .logo {
    margin: 220px auto 130px auto;
    text-align: center;
    img {
      width: 400px;
    }
  }
  .tab-wrapper {
    width: 100%;
    height: 80px;
    line-height: 1;
    margin: 10px auto;
    border: 1px solid #269cca;
    .tab-li {
      width: 50%;
      height: inherit;
      line-height: 3;
      display: inline-block;
      float: left;
      text-align: center;
      background-color: #fff;
      color: #269cca;
      &.active {
        background-color: #269cca;
        color: #fff;
      }
    }
  }
  .content {
    padding: 0 40px;

    .login-qrcode {
      width: 160px;
      margin: 0 auto;
      margin-top: 88px;
      color: #333;
      font-size: 26px;

      > img {
        width: 100%;
      }
    }
  }
  .van-cell-group {
    &.van-hairline--top-bottom::after {
      border-width: 0;
    }
    .van-cell:not(:last-child)::after {
      left: 0;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
      border-top: none;
    }
    .van-button--primary {
      background: #269cca;
      border-color: #269cca;
      margin: 20px 0;
    }
  }
  .link {
    color: #269cca;
    margin: 20px 0;
    font-size: 28px;
  }
  .forget-pwd {
    text-align: right;
    width: 150px;
    float: right;
  }
  .register-link {
    text-align: center;
  }
  .link-wrap {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
}
.vant-set{
  padding-top: 10px;
  padding-bottom: 10px;
  border:1px solid #269cca
}
</style>



// WEBPACK FOOTER //
// src/views/member/login.vue